/**
 * Skills, drawn.
 *
 * The five spells are the game's entire effects budget, and they are
 * good enough that inventing a second, worse effects system for the Lineage
 * skills would be a strange thing to do. So each skill names one of them and
 * this file is the whole of the translation: where it goes off, and in which
 * direction.
 *
 * None of the triggers gate themselves — a recast simply restarts — so every
 * cooldown, cast time and range check lives in `combat.js` and nowhere else.
 */

/**
 * @param {import("../spells/spellSystem.js").SpellSystem} spells
 * @param {string} vfx
 * @param {{
 *   origin: {x:number,y:number,z:number},
 *   target: {x:number,y:number,z:number}|null,
 * }} where
 */
export function playSkillVfx(spells, vfx, where) {
    if (!vfx) return;
    const { origin, target } = where;

    switch (vfx) {
        case "sweep": {
            // A ground-hugging crescent thrown from the caster towards the
            // target; flattened, because a target uphill would otherwise launch
            // it over the player's head.
            const dx = (target?.x ?? origin.x) - origin.x;
            const dz = (target?.z ?? origin.z) - origin.z;
            const len = Math.hypot(dx, dz) || 1;
            spells.sweep.trigger(dx / len, dz / len);
            break;
        }
        case "ribbon":
            // A held cast: `combat.js` holds it for the cast time and lets go on
            // impact, which is what makes the water land with the damage.
            spells.holdRibbon(true);
            break;
        case "crystallize":
            if (target) spells.crystallize.trigger(target.x, target.y, target.z);
            break;
        case "bloom":
            spells.bloom.trigger(origin.x, origin.y, origin.z);
            break;
        case "vortex":
            spells.vortex.trigger();
            break;
        default:
            break;
    }
}

/** Let go of anything that is held. Called when a cast finishes or is cancelled. */
export function releaseHeldVfx(spells) {
    spells.holdRibbon(false);
}
